import React from "react"
import { useRouter } from "next/navigation"

function useDebouncedRouterPush(delay = 300) {
  const router = useRouter()
  const timeoutRef = React.useRef<NodeJS.Timeout | null>(null)

  const push = React.useCallback(
    (path: string) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      timeoutRef.current = setTimeout(() => {
        router.push(path)
      }, delay)
    },
    [router, delay]
  )

  return push
}

export default useDebouncedRouterPush
